import { Route } from '@angular/router';

export const RESOURCES_ROUTES: Route[] = [
  { path: '', loadComponent: () => import('./components/resources/resources.component').then(m => m.ResourcesComponent) }
];
